import { render } from "./GroupOrder.vue?vue&type=template&id=5982b361&scoped=true"
import script from "./GroupOrder.vue?vue&type=script&lang=js"
export * from "./GroupOrder.vue?vue&type=script&lang=js"

import "./GroupOrder.vue?vue&type=style&index=0&id=5982b361&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5982b361"]])

export default __exports__